// Object that enumerates all possible types of UI elements/components an in-product notification can be rendered as.
// Maintaining this enumeration helps create a single source of truth for IPN component types and ensures consistency across different IPN implementations.
// If you are unsure which type to use, or if you want to update this enumeration, reach out to the Shared Services team.
export const IPN_TYPE = {
  BANNER: 'banner',
  CARD: 'card',
  CARD_WITH_BUTTON: 'card_with_button',
  CARD_WITH_IMAGE: 'card_with_image',
  MODAL: 'modal',
  MODAL_WITH_IMAGE: 'modal_with_image',
  POPOVER: 'popover',
  TOAST: 'toast',
} as const;

export type IpnType = (typeof IPN_TYPE)[keyof typeof IPN_TYPE];
